/* eslint-disable @typescript-eslint/no-explicit-any */
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription, of, BehaviorSubject, take, switchMap } from 'rxjs';
import { Store } from '@ngrx/store';
import { PggFlowComponent } from '../base-components/pgg-flow/pgg-flow.component';
import { IndexedDbService, getActiveManifestItem, ModalService, ManifestController, BigFormService } from '@flexus/core';
import { PggWorkflowShellComponent } from '../base-components/pgg-workflow-shell/pgg-workflow-shell.component';
import { PggService } from '../services/pgg.service';


@Injectable()
export class DeactivateStateGuard implements OnDestroy, CanDeactivate<PggFlowComponent | PggWorkflowShellComponent> {
	canGo$ = new BehaviorSubject(false);
	canDiscard: boolean;
	manifestItem;
	manifestItemSub: Subscription;
	
	constructor(
		public indexedDbService: IndexedDbService,
		private controller: ManifestController<any>,
		public store: Store<any>,
		public modalService: ModalService,
		public bf: BigFormService,
		public router: Router,
		public pggService: PggService
	) {
		console.log('🛡️🛡️🛡️ DeactivateStateGuard constructor called');
		this.manifestItemSub = this.controller
			.select(getActiveManifestItem)
			.pipe(take(1))
			.subscribe(item => (this.manifestItem = item));
		console.log('🛡️ Guard initialized, canGo$ initial value:', this.canGo$.value);
		
		// Monitor canGo$ subscription
		this.canGo$.subscribe(value => {
			console.log('🔄🔄🔄 canGo$ emitted:', value);
		});
	}

	canDeactivate(
		component: PggFlowComponent,
		currentRoute: ActivatedRouteSnapshot,
		currentState: RouterStateSnapshot,
		nextState: RouterStateSnapshot
	): Observable<boolean> | boolean | Promise<boolean> {
		console.log('🚨🚨🚨 canDeactivate called, navigating from', currentState.url, 'to:', nextState.url);
		
		// Get fresh manifestItem each time instead of relying on cached value
		return this.controller.select(getActiveManifestItem).pipe(
			take(1),
			switchMap((manifestItem): Observable<boolean> => {
				console.log('🚨 manifestItem exists:', !!manifestItem, 'has deactivateStateGuard:', !!manifestItem?.deactivateStateGuard);
				if (manifestItem && manifestItem.deactivateStateGuard) {
					console.log('🚨 Calling manifestItem.deactivateStateGuard...');
					const result = manifestItem.deactivateStateGuard(this, component, this.router, currentRoute, currentState, nextState);
					console.log('🚨 canDeactivate returning type:', typeof result, 'isObservable:', result && typeof result.subscribe === 'function');
					if (result && typeof result.subscribe === 'function') {
						// Subscribe to see what it emits
						result.subscribe(val => console.log('🚨 Observable emitted value:', val));
						return result as Observable<boolean>;
					}
					return of(result as boolean);
				} else {
					console.log('🚨 No guard defined, allowing navigation');
					return of(true);
				}
			})
		);
	}

	resetCanGoVariable() {
		console.log('🔄 resetCanGoVariable called');
		this.canGo$.next(false);
	}

	ngOnDestroy() {
		if (this.manifestItemSub) this.manifestItemSub.unsubscribe();
	}
}
